import { render } from "./Main.html?vue&type=template&id=c9245b52&scoped=true&ts=true&external"
import script from "./Main.ts?vue&type=script&lang=ts&external"
export * from "./Main.ts?vue&type=script&lang=ts&external"

import "./Main.scss?vue&type=style&index=0&id=c9245b52&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9245b52"]])

export default __exports__